/** Port of `buildStartDate()`/`formatDate()`, producing an HTML `<input type="date">` value. */
export function buildTodayDateInputValue() {
  const date = new Date()
  const pad = (n) => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

/**
 * Port of `$scope.save`'s inline `dueDate` validation:
 *
 *   if ($scope.discountCoupon.dueDate && $scope.discountCoupon.dueDate !== "") {
 *     const splittedDate = $scope.discountCoupon.dueDate.split("/");
 *     if (splittedDate.length !== 3) return;
 *     const [day, month, year] = splittedDate;
 *     const parsedDate = new Date(Number(year), Number(month) - 1, Number(day));
 *     if (parsedDate <= new Date()) {
 *       Materialize.toast("A expiração deve ser uma data futura", 6000);
 *       return;
 *     }
 *   }
 *
 * `dueDateValue` is the native `YYYY-MM-DD` input value; `new Date(value)`
 * parses that directly (no split needed, unlike the legacy `dd/mm/yyyy`
 * text). Returns `'invalid-format'` / `'not-future'` / `null` (valid) so the
 * caller can reproduce the two distinct legacy branches (silent no-op vs.
 * toast).
 */
export function validateDueDate(dueDateValue) {
  if (!dueDateValue) return null

  const parsedDate = new Date(dueDateValue)
  if (Number.isNaN(parsedDate.getTime())) return 'invalid-format'
  if (parsedDate <= new Date()) return 'not-future'
  return null
}
